import React from "react";
import useSidebar from "../../hooks/useSidebar";
import { Navbar, Nav } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";

import NavbarUser from "./NavbarUser";

const NavbarComponent = () => {
  const { isOpen, setIsOpen } = useSidebar();
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;
    console.log("New path:", pathname, isMobile);
    if (isMobile && isOpen) setIsOpen(false);
  }, [location.pathname, isMobile]);

  return (
    <Navbar variant="light" expand className="navbar-bg">
      <span
        className="sidebar-toggle d-flex"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <i className="hamburger align-self-center" />
      </span>

      <Navbar.Collapse>
        <Nav className="navbar-align">
          <NavbarUser />
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarComponent;
